
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import actual from './estadisticas-viajante-actual.vue';
    import ventas from './estadisticas-viajante-ventas.vue';
    import articulos from './estadisticas-viajante-articulos.vue';
import { Viajante } from '@/__env/lib/Ventas/Viajantes';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            actual,
            ventas,
            articulos,
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public tab: string = '';
        public Estado: 'ok' | 'cargando' = 'cargando';
        Viajante: Viajante = new Viajante();

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        async mounted()
        {
            this.Eventos.push( this.Controlador.onActualizarFavoritos.subscribe( () => this.Refrescar() ) );
            this.Viajante = this.Controlador.ViajanteSeleccionado;
            this.Estado = "ok";
        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }

    }
